import React from 'react';
import { Award, Heart, Sparkles } from 'lucide-react';
import { storyData } from '../data/mock';

const StorySection = () => {
  return (
    <section className="story-section py-20 md:py-32 relative overflow-hidden">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 mb-4 story-badge">
              <Heart className="h-5 w-5" />
              <span className="text-sm font-semibold uppercase tracking-wider">Our Story</span>
            </div>
            <h2 className="text-4xl md:text-6xl font-bold mb-6">
              {storyData.title}
            </h2>
            <p className="text-xl md:text-2xl font-medium story-subtitle">
              {storyData.subtitle}
            </p>
          </div>

          <div className="story-card rounded-3xl p-8 md:p-12 mb-12">
            <p className="text-lg md:text-xl leading-relaxed mb-8">
              {storyData.content}
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {storyData.highlights.map((highlight, index) => (
                <div 
                  key={index}
                  className="highlight-card text-center p-6 rounded-2xl"
                >
                  <div className="highlight-icon mx-auto mb-4">
                    {index === 0 && <Award className="h-8 w-8" />}
                    {index === 1 && <Sparkles className="h-8 w-8" />}
                    {index === 2 && <Heart className="h-8 w-8" />}
                  </div>
                  <div className="text-sm uppercase tracking-wider font-semibold mb-2 opacity-70">
                    {highlight.label}
                  </div>
                  <div className="text-2xl font-bold">
                    {highlight.value}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="text-center">
            <div className="inline-flex items-center gap-3 worlds-first-badge px-8 py-4 rounded-full">
              <Award className="h-6 w-6" />
              <span className="text-lg font-bold">World's First Vegan & Gluten-Free Bakery</span>
            </div>
          </div>
        </div>
      </div>

      <div className="story-decoration story-decoration-1"></div>
      <div className="story-decoration story-decoration-2"></div>
    </section>
  );
};

export default StorySection;
